import { render, staticRenderFns } from "./wallet-transactions-table.vue?vue&type=template&id=645bd458&"
import script from "./wallet-transactions-table.vue?vue&type=script&lang=js&"
export * from "./wallet-transactions-table.vue?vue&type=script&lang=js&"
import style0 from "./wallet-transactions-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QInnerLoading,QSpinnerIos,QTr,QTh,QTd,QBtn,QTooltip,QIcon,QImg,QCard} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QInnerLoading,QSpinnerIos,QTr,QTh,QTd,QBtn,QTooltip,QIcon,QImg,QCard})
